import React from "react";
import styled from "styled-components";
import constants from "./constants";

const Link = styled.a`
  font-family: ${({ uiKitConfiguration }) => {
    return uiKitConfiguration.font_family || "Arial";
  }};

  text-decoration: underline;
  color: ${({ uiKitConfiguration }) => {
    return (
      (uiKitConfiguration.colors &&
        uiKitConfiguration.colors["color-primary-500"]) ||
      constants.defaults.link.color
    );
  }};

  &:hover {
    /* text-decoration: none; */

    color: ${({ uiKitConfiguration }) => {
      return (
        (uiKitConfiguration.colors &&
          uiKitConfiguration.colors["color-primary-800"]) ||
        constants.defaults.link.hover.color
      );
    }};
  }
`;

export default Link;
